module.exports = __webpack_public_path__ + "media/images/athletes/2815-b7df70c6bdefccd5d12038f74c8c5d66.png";